export const getQueryParams = (items = {}, reset = false) => {
  const urlSearchParams = new URLSearchParams(reset ? '' : location.search)
  Object.keys(items).forEach((key) => {
    const value = items[key]
    if (value !== undefined) {
      urlSearchParams.set(key, value)
    } else {
      urlSearchParams.delete(key)
    }
  })
  return urlSearchParams.toString()
}

export const getUrlWithQueryParams = (items = {}, reset = false) => {
  const urlOrigin = window.location.href.replace(location.search, '')
  const queryParams = getQueryParams(items, reset)
  return queryParams ? `${urlOrigin}?${queryParams}` : urlOrigin
}

export const getParam = (queryKey) => {
  return new URLSearchParams(location.search).get(queryKey)
}
